import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBookingsChangeBedStatus({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M14.584 7.62l.923.727c.49.385.574 1.093.19 1.58l-4.416 5.614-1.704.397a.795.795 0 01-.975-.767l-.015-1.75 4.418-5.613a1.123 1.123 0 011.579-.188zm-9.137.544a4.677 4.677 0 003.68.097l.226-.097H9.8c.436 0 .854.078 1.241.22l-3.794 4.642-.001 1.138h-4.56a1.286 1.286 0 01-1.28-1.154l-.006-.131v-1.115A3.601 3.601 0 014.809 8.17L5 8.164h.447zM7.4.45a3.428 3.428 0 110 6.857A3.428 3.428 0 017.4.45z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBookingsChangeBedStatus.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBookingsChangeBedStatus.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBookingsChangeBedStatus svgRef={ref} {...props} />
));
export default ForwardRef;
